/**
 * Surveys / quizzes backend capabilities (release 2026-11 § 2: BE-151, BE-186, BE-201, BE-153,
 * BE-138). The lifestyle quiz itself has no flag: its questions come only from
 * `GET /surveys/default-lifestyle-survey/config` (BE-152). Off → the quiz keeps the pre-release
 * wire shape where one exists; on → the real call:
 *   VITE_SURVEYS_API="style_scale,quiz_progress"   (or "all")
 * Dev / preview override: localStorage.setItem('fair:surveys-api', 'all') → reload.
 */
import { resolveCapabilities } from '@/shared/capabilities'

export const SURVEYS_API_CAPABILITIES = [
  /** BE-151 — swipes carry the 0…100 score, `cards_per_style` on the session, `rarely` for heels */
  'style_scale',
  /** BE-186 — `GET|PUT|DELETE /user/quiz-progress/{kind}`; off → the step is not remembered */
  'quiz_progress',
  /** BE-201 / BE-186 — `units`, `language`, `currency` on `/user/profile`; off → not persisted */
  'profile_locale',
  /** BE-153 / BE-138 / BE-150 — people as gift recipients with taste, `GET /gift/config` */
  'gift_recipients',
  /** Decision 4 — `GET /gift/ideas` (ML, search fallback on the server); off → the quiz's own search */
  'gift_ideas',
] as const

export type SurveysApiCapability = (typeof SURVEYS_API_CAPABILITIES)[number]

export const SURVEYS_API_STORAGE_KEY = 'fair:surveys-api'

const enabled = resolveCapabilities(
  import.meta.env.VITE_SURVEYS_API,
  SURVEYS_API_STORAGE_KEY,
  SURVEYS_API_CAPABILITIES,
)

export function hasSurveysApi(capability: SurveysApiCapability): boolean {
  return enabled.has(capability)
}
